export const SITE_ORIGIN = 'https://chisme.social';
export const SITE_NAME = 'Chisme';
